import type { SVGProps } from 'react'

import { IconTemplateIPortIcon } from '../template/IconTemplateIPortIcon'
import { CustomIconProps } from '../types/types'

export const SvgArrowLink = (props: SVGProps<SVGSVGElement> & CustomIconProps) => {
	return (
		<IconTemplateIPortIcon {...props}>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M6.9106 14.0847C7.10368 14.2985 7.43929 14.2982 7.63204 14.0841L11.6075 9.66915C11.95 9.28879 11.95 8.71121 11.6075 8.33085L7.67472 3.96327C7.45915 3.72386 7.08379 3.72356 6.86783 3.96262C6.68098 4.16946 6.68098 4.48415 6.86783 4.69099L10.4576 8.66483C10.6295 8.85519 10.6295 9.14481 10.4576 9.33517L6.9106 13.2617C6.69946 13.4954 6.69946 13.851 6.9106 14.0847Z"
					fill="#568DFE"
				/>
			</svg>
		</IconTemplateIPortIcon>
	)
}
